import React, { useState } from 'react'

import { Card } from 'antd'
import { isFunction } from 'lodash'
import moment from 'moment'
import { useSelector } from 'react-redux'

import PlaceAllocationForm from './forms/PlaceAllocationForm'
import QuickDualDatePickers from '../shared/QuickDualDatePickers'
import { BACKEND_DATE_FORMAT } from '../../../../utils/constants'
import { faBan, faEdit, faSave, faTrash } from '@fortawesome/pro-solid-svg-icons'
import TooltipIconButton from '../../../antd/Buttons/TooltipIconButton'
import PopoverIconButton from '../../../antd/Buttons/PopoverIconButton'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { Properties } from '../../../../utils/entities'

export const POPOVER_CONTENT = 'Are you sure you want to delete this quota?'

const QuotaCard = ({ data = null, sections = [], sectionGroups = [], onDelete, onPlacesChanged, onSave }) => {
  const t = useSelector(selectTranslate)

  const [quota, setQuota] = useState(data)
  const [oldQuota, setOldQuota] = useState(null)

  const disabled = oldQuota === null

  const handleEdition = () => {
    setOldQuota({ ...quota })
  }

  const handleSuppression = () => {
    if (isFunction(onDelete)) {
      onDelete(data)
    }
  }

  const handleEditionCancel = () => {
    if (isFunction(onPlacesChanged)) {
      onPlacesChanged(quota.total - oldQuota.total)
    }

    setQuota({ ...oldQuota })
    setOldQuota(null)
  }

  const handleSave = () => {
    setOldQuota(null)

    if (isFunction(onSave)) {
      onSave(quota)
    }
  }

  const updateQuotaDates = dates => {
    const newQuota = { ...quota }

    newQuota.startDate = dates[0].format(BACKEND_DATE_FORMAT)
    newQuota.endDate = dates[1].format(BACKEND_DATE_FORMAT)

    setQuota(newQuota)
  }

  const handleChange = (value, property) => {
    if (property === Properties.TOTAL && isFunction(onPlacesChanged)) {
      onPlacesChanged(quota.total - value)
    }

    setQuota({ ...quota, [property]: value })
  }

  const renderCardActions = () => {
    if (!disabled) {
      return (
        [
          <TooltipIconButton
            key='card-save-button'
            title={t('Save')}
            onClick={handleSave}
            disabled={!quota.section && !quota.sectionGroup}
            icon={faSave}
          />,
          <TooltipIconButton
            key='card-cancel-button'
            title={t('Cancel')}
            onClick={handleEditionCancel}
            icon={faBan}
          />
        ]
      )
    }

    return ([
      <TooltipIconButton
        key='card-edit-button'
        title={t('Edit')}
        onClick={handleEdition}
        icon={faEdit}
      />,
      <PopoverIconButton
        key='card-trash-button'
        title={t('Delete')}
        tooltipTitle='Delete'
        content={POPOVER_CONTENT}
        onConfirm={handleSuppression}
        icon={faTrash}
      />
    ])
  }

  return (
    <Card
      style={{ width: '100%', marginBottom: '10px' }}
      actions={renderCardActions()}
    >
      <QuickDualDatePickers
        startDate={quota ? moment(quota.startDate) : moment()}
        endDate={quota ? moment(quota.endDate) : moment()}
        onDatesChange={updateQuotaDates}
        disabled={disabled}
      />
      <PlaceAllocationForm
        disabled={disabled}
        quota={quota}
        sections={sections}
        sectionGroups={sectionGroups}
        onChange={handleChange}
      />
    </Card>
  )
}

export default QuotaCard
